import { useCallback, useEffect, useState } from 'react';
import MyContext from '../../02Contexts/Mycontext';
import InputComponent from "./InputComponent/Inputcomponent";
import MapComponent from "./MapComponent/MapComponent";
import './HomeComponent.scss';
import { methodGET } from '../../infra/api';

export default function HomeComponent() {

    const [map, setMap] = useState(null)
    const [location, setLocation] = useState(JSON.parse(localStorage.getItem('location')))
    const [details, setDetails] = useState(null)
    const [radius, setRadius] = useState(5000)
    const [inputRadius, setInputRadius] = useState(5)

    const [list, setList] = useState([])
    const [productList, setProductList] = useState([{ value: 0, label: 'Todos' }])
    const [productType, setProductType] = useState(0)

    async function getProductsList() {
        await methodGET('PRODUTOS/VIEW').then((result) => {
            if (result.status === 200) {
                let options = result.data.map(item => {
                    return ({
                        value: item.codigo_produto,
                        label: item.nome_produto
                    })
                })
                setProductList([{ value: 0, label: 'Todos' }].concat(options))
            }
        })
    }

    function maskSegmento(text) {
        switch (text) {
            case 'SUPERMERCADOS E MERCADOS':
                return ('Mercado');
            case 'CASA DE CARNES':
                return ('Mercado');
            case 'PIZZARIAS E LANCHERIAS':
                return ('Restaurante');
            case 'RESTAURANTES E BARES':
                return ('Restaurante');
            case 'PANIFICADORA':
                return ('Restaurante');
            case 'LOJAS DE CONVENIENCIA E POSTOS DE COMBUSTIVEIS':
                return ('Posto');
            case 'FARMACIA':
                return ('Farmácia');
            default:
                return (text)
        }
    }

    const getLocations = useCallback(async () => {
        await methodGET(`BY-DISTANCE-RAIO/${productType}/${location.lat}/${location.lng}/${inputRadius}`).then((result) => {
            if (result.status === 200) {
                let options = result.data.map(item => {
                    return ({
                        name: item.nome,
                        fulltime: item.fulltime,
                        adress: item.logradouro + ', ' + item.numero,
                        city: item.bairro + ' - ' + item.cidade + '/' + item.estado,
                        time: item.start + ' às ' + item.end,
                        phone: item.telefone,
                        segmento: maskSegmento(item.segmento),
                        location: [parseFloat(item.latitude), parseFloat(item.longitude)],
                        cards: item.lista_produtos ? item.lista_produtos.split(', ') : []
                    })
                })
                setList(options)
            }
        })
    }, [productType, location, inputRadius])

    useEffect(() => {
        getProductsList()
    }, [])

    useEffect(() => {
        if (location !== null) {
            getLocations()
        }
    }, [location, setLocation, productType, setProductType, getLocations])

    return (
        <div id='body'>
            <MyContext.Provider value={{
                location, setLocation, radius, setRadius,
                list, setList, details, setDetails, map, setMap,
                productList, productType, setProductType, inputRadius, setInputRadius
            }}>
                <InputComponent />

                <MapComponent />
            </MyContext.Provider>
        </div>
    )
}